import * as React from 'react'

export const UnshelteredIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M15.9992 5.50044L18.9992 8.50044L16.9992 9.50044L20.9992 13.5004L17.9992 14.5004L21.9992 18.5004H12.9992M14.9992 21.5004V18.5004M7.99922 13.5004L5.99922 11.5004M7.99922 12.5004L9.99922 10.5004M7.99922 21.5004V8.50044M5.82322 16.5004C5.38569 16.4748 4.95909 16.3536 4.57342 16.1454C4.18775 15.9372 3.85239 15.6471 3.59092 15.2953C3.32945 14.9436 3.14823 14.5388 3.05999 14.1095C2.97176 13.6802 2.97866 13.2368 3.08022 12.8104C2.71769 12.5085 2.43147 12.1254 2.24481 11.6921C2.05815 11.2588 1.9763 10.7876 2.00592 10.3168C2.03553 9.84596 2.17578 9.38873 2.41526 8.98226C2.65475 8.57579 2.98672 8.23153 3.38422 7.97744C3.03559 7.35809 2.91817 6.63509 3.05288 5.93724C3.18759 5.2394 3.56568 4.61205 4.11978 4.16697C4.67388 3.72188 5.36801 3.48798 6.07848 3.50693C6.78896 3.52588 7.46963 3.79645 7.99922 4.27044C8.52893 3.7972 9.20937 3.52727 9.91945 3.50869C10.6295 3.4901 11.3232 3.72408 11.8769 4.16896C12.4306 4.61385 12.8085 5.24078 12.9434 5.93819C13.0782 6.63559 12.9612 7.35821 12.6132 7.97744C13.0108 8.23145 13.3428 8.57564 13.5824 8.98207C13.822 9.3885 13.9623 9.8457 13.992 10.3165C14.0218 10.7874 13.94 11.2586 13.7534 11.6919C13.5668 12.1253 13.2807 12.5085 12.9182 12.8104C13.0232 13.2512 13.0269 13.7101 12.9292 14.1525C12.8315 14.595 12.6348 15.0096 12.3539 15.3651C12.073 15.7207 11.7152 16.008 11.3074 16.2055C10.8996 16.403 10.4523 16.5055 9.99922 16.5054H5.99922L5.82322 16.5004Z"
      stroke="#4F5B94"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export default UnshelteredIcon
